import { html } from 'lit-element';
// TODO: release link
// import '@forter/link';

export const input = ({
  cellData,
  selected = [],
  datePickerOptions,
  column: { label, fromKey, type, maskType, mask, required, filter } = {},
}) => {
  return filter && filter.values ? html`
    <fc-select
      path=${fromKey}
      style="--fc-select-height: 25px;--fc-select-width: 100%"
      value=${isNaN(cellData) ? cellData || '' : cellData}
      ?required=${required}>
      ${filter.values.map(option => html`<option value="${isNaN(option.value) ? option.value || option.label : option.value}">${option.label || option.value}</option>`)}
    </fc-select>
  ` : type === 'DATE' ? html`
    <fc-date-picker
      path=${fromKey}
      style="--fc-default-height: 25px;--fc-date-picker-width: 100%;--fc-date-picker-input-width: 100%;"
      ?required=${required}
      .dates=${cellData ? [`${cellData}`] : []}
      .pickerOptions=${datePickerOptions}
      format="DD MMM YYYY HH:mm"></fc-date-picker>
  ` : !maskType ? html`
    <fc-input
      ?required=${required}
      type=${type === 'number' ? 'number' : 'text'}
      label="${label}"
      path=${fromKey}
      value=${selected.length === 1 ? cellData : ''}
    ></fc-input>
  ` : html`
    <fc-mask type=${maskType} pattern=${mask}><fc-input
      ?required=${required}
      type=${type === 'number' ? 'number' : 'text'}
      label="${label}"
      path=${fromKey}
      value=${selected.length === 1 ? cellData : ''}
    ></fc-input></fc-mask>
  `;
};
